import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = {
  key: 0,
  class: "form-field"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Pick Rental", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Fee/Retail", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a Fee/retail", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Service", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a Service", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Total")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Cancel", -1)
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" No ledgers to add fees to ")

import { useRouter } from "vue-router";
import InvoiceableModal from "@/components/InvoiceableModal.vue";
import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";
import moment from "moment";
import api from "@virgodev/bazaar/functions/api";
import { InvoiceableInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: true,
  },
  customerName: {
    type: String,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  emits: ["feesAndProducts"],
  setup(__props, { emit }) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const router = useRouter();
const feesAndRetails = ref();
const items = ref();
const services = ref();
const newFeeAndRetail = ref<InvoiceableInterface | null>();
const feesAndProducts = ref(Array<InvoiceableInterface>());
const total = ref(0);
const newService = ref<InvoiceableInterface | null>();
const errors = ref("");

const customer = ref();
const ledgers = ref();

const ledgerId = ref();
async function addCost(e: InvoiceableInterface) {
  feesAndProducts.value.push(e);
  total.value += Number(e.amount);
  emit("feesAndProducts", e);
}
function removeFee(obj: InvoiceableInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item: InvoiceableInterface) => item == obj)
    ),
    1
  );
  total.value -= Number(obj.amount);
  emit("feesAndProducts", feesAndProducts.value);
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];

    await getLedgers();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getLedgers() {
  errors.value = "";
  let response;
  ledgers.value = [];
  if (!api_settings.use_contact_id) {
    if (
      customer.value.current_ledger_ids &&
      !api_settings.customer_id_with_ledgers
    ) {
      response = await api({
        url: `ledgers/?only_ids=${customer.value.current_ledger_ids.join(
          ","
        )}&include_as_object=events&facilityId=${props.facilityId}`,
      });
    } else {
      response = await api({
        url: `ledgers/?id=${props.customerId}&facilityId=${props.facilityId}`,
      });
    }
    if (response.status == 200) {
      if (response.body.ledgers) {
        ledgers.value = response.body.ledgers;
      } else {
        ledgers.value = response.body;
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  } else {
    ledgers.value = customer.value.rentals;
    customer.value.current_ledger_ids = [];
    for (let rental of ledgers.value) {
      customer.value.current_ledger_ids.push(rental.id);
    }
  }
}
async function submitForm() {
  if (ledgerId.value) {
    for (let line of feesAndProducts.value) {
      let lineId = line.id;
      if (line.service_id) {
        lineId = line.service_id;
      }
      let json;
      let fee;
      if (api_settings.uses_description_fees) {
        fee = {
          invoiceable_item_id: lineId,
          amount: line.amount,
          description: line.description,
          notes_attributes: [{ note: line.note }],
          date: moment().format("YYYY-MM-DD"),
        };
      } else if (api_settings.uses_amount_fees) {
        fee = {
          invoiceable_item_id: lineId,
          amount: line.amount,
          notes_attributes: [{ note: line.note }],
        };
      } else {
        fee = {
          invoiceable_item_id: lineId,
          notes_attributes: [{ note: line.note }],
        };
      }
      json = JSON.parse(
        JSON.stringify({
          add_fee: fee,
        })
      );

      formSubmitting.value = true;
      let url = `fees/?id=${ledgerId.value}&facilityId=${props.facilityId}`;

      const responseData = await api({
        url,
        method: "POST",
        json,
      });
      if ([200, 201].includes(responseData.status)) {
        router.push({
          name: "customer_detail_storedge",
          params: {
            id: props.customerId,
            facilityId: props.facilityId,
          },
        });
      } else if (responseData.status === 400) {
        formErrors.value = responseData.body;
      } else {
        formErrors.value = {
          non_field_errors: [
            "Unable to communicate with the server. Please check your " +
              "connection and try again.",
          ],
        };
      }
    }
    router.push({
      name: "customer_detail_storedge",
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else {
    alert("Please select Rental");
  }
}
async function modalClosed() {
  newFeeAndRetail.value = null;
  newService.value = null;
}
async function getInvoiceableItems() {
  errors.value = "";
  const response = await api({
    url: `invoiceable_items/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.invoiceable_items) {
      items.value = response.body.invoiceable_items;
      services.value = items.value.filter(
        (item: InvoiceableInterface) => item.kind == "service"
      );
      feesAndRetails.value = items.value.filter((item: InvoiceableInterface) =>
        ["fee", "retail"].includes(item.kind)
      );
    } else {
      items.value = response.body;
      services.value = [];
      feesAndRetails.value = items.value;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getInvoiceableItems();
if (props.customerId) {
  getCustomer();
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerName)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {
      name: 'customer_detail_storedge',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (__props.customerName)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Fees, Retail, and Services"))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      style: {"margin-inline":"10px !important"},
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      (ledgers.value && ledgers.value.length && __props.customerName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ledgerId).value = $event)),
              class: "form-select",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ledgers.value, (ledger) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: ledger.id + 'ledger',
                  value: ledger.id
                }, _toDisplayString(ledger.unit.name), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, ledgerId.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (newFeeAndRetail.value)
        ? (_openBlock(), _createBlock(InvoiceableModal, {
            key: 1,
            name: newFeeAndRetail.value.description,
            "customer-id": __props.customerId,
            "fee-id": newFeeAndRetail.value.id,
            type: "fee",
            amount: newFeeAndRetail.value.total,
            onModalClosed: modalClosed,
            onFee: addCost
          }, null, 8, ["name", "customer-id", "fee-id", "amount"]))
        : _createCommentVNode("", true),
      (newService.value)
        ? (_openBlock(), _createBlock(InvoiceableModal, {
            key: 2,
            name: newService.value.description,
            "customer-id": __props.customerId,
            "fee-id": newService.value.id,
            amount: newService.value.total,
            type: "service",
            onModalClosed: modalClosed,
            onFee: addCost
          }, null, 8, ["name", "customer-id", "fee-id", "amount"]))
        : _createCommentVNode("", true),
      (!__props.customerName || (ledgers.value && ledgers.value.length && __props.customerName))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newFeeAndRetail).value = $event)),
                class: "form-select"
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feesAndRetails.value, (fee) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: fee.id + 'fee',
                    value: fee
                  }, _toDisplayString(fee.description) + " - $" + _toDisplayString(fee.total), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, newFeeAndRetail.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newService).value = $event)),
                class: "form-select"
              }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: service.id + 'service',
                    value: service
                  }, _toDisplayString(service.description), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, newService.value]
              ])
            ]),
            (feesAndProducts.value && feesAndProducts.value.length && __props.customerName)
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feesAndProducts.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id + 'fees'
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.description), 1),
                      _createElementVNode("td", null, "$" + _toDisplayString(item.amount), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (removeFee(item))
                        }, "remove", 8, _hoisted_15)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    _hoisted_16,
                    _createElementVNode("td", null, "$" + _toDisplayString(total.value.toFixed(2)), 1),
                    _hoisted_17
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.customerName)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn",
                  type: "submit",
                  disabled: formSubmitting.value
                }, " Save ", 8, _hoisted_18))
              : _createCommentVNode("", true),
            (__props.customerName)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 2,
                  to: {
          name: 'customer_detail_storedge',
          params: { id: __props.customerId, facilityId: __props.facilityId },
        }
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2),
    (__props.customerName && ledgers.value && ledgers.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (__props.customerName)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_21
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})